<template>

    <v-navigation-drawer app location="left"  width="250" height="100%" class="k-app-sidebar">
      <div class="k-app-sidebar-body">
      </div>

      <div class="k-app-sidebar-footer">
        <div class="pa-3">
          <p class="text-overline">Settings</p>
        </div>
        <v-list class="menu-small" density="compact" nav :lines="false" :color="`var(--primary)`">

          <v-list-item v-for="(item, index) in getMenuItemsFooter()" :key="index" :to="item.to">
            <template v-slot:prepend>
              <div class="menu-icon-left">
                <i :class="`fal ${item.icon}`"></i>
              </div>
            </template>
            <template v-slot:append>
              <v-chip v-if="item.append" variant="flat" size="small" color="red">{{ item.append }}</v-chip>
            </template>

            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <template v-slot:prepend>
              <div class="menu-icon-left">
                <i :class="`fal fa-sign-out`"></i>
              </div>
            </template>

            <v-list-item-title v-text="'Sign out'"></v-list-item-title>
          </v-list-item>
        </v-list>

      </div>
    </v-navigation-drawer>
</template>

<script>
import { mapState } from "pinia";
import { useMainStore } from "@/stores/store";

export default {
  props: {
    drawer: Boolean
  },
  data() {
    return {
    
    };
  },

  computed: {
    ...mapState(useMainStore, ["user", "kyano"]),


  },
  methods: {
    getMenuItems() {
      return [
        // { title: "Dashboard", to: `/`, icon: "fa-home-alt" },
      ];
    },

    getMenuItemsFooter() {
      return [
        {
          title: "My account",
          to: `/account`,
          icon: "fa-user",
        },
        {
          title: "Settings",
          to: `/settings`,
          icon: "fa-cog",
        },

      ];
    },


    logout() {
      cookies.remove('kyano_access_token');
      cookies.remove('kyano_user');
      location.replace('/login');
    },
  },

};
</script>